/* eslint-disable @typescript-eslint/no-namespace */
/**
 * Static enums extracted from: @tencent/tpro_rmonitor_product_manager_user
 * DO NOT EDIT MANUALLY — run "npm run gen:proto-enums" to regenerate.
 *
 * Zero dependencies — only static enum definitions.
 * Supports nested namespace access: enumTrpc.rmonitor.web_server.IssueType
 */

export namespace enumTrpc {
  export namespace rmonitor {
    export namespace product_manager {
      export enum BindingStatusEnum {
        UnknownStatus = 0,
        UnBinding = 1,
        UnFollow = 2,
        HasBinding = 3,
      }

      export enum CodeType {
        UNKNOWNCODETYPE = 0,
        PHONE = 1,
        MAIL = 2,
      }

      export enum VerifyType {
        VERIFYTYPEBUGLY = 0,
        VERIFYTYPESHIPLY = 1,
      }

      export enum ProductType {
        UNKNOWN_PRODUCT = 0,
        PAID_PRODUCT = 1,
        FREE_PRODUCT = 2,
        NORMAL_PRODUCT = 3,
      }

      export enum PlatformType {
        UNKNOWN_PLATFORM = 0,
        ANDROID = 1,
        IPHONE = 2,
        MAC = 4,
        LINUX = 5,
        FLUTTER = 9,
        WINDOWS = 10,
        HARMONY = 11,
        Hippy = 14,
        Kuikly = 15,
        VisionOS = 17,
        MiniProgram = 18,
        Electron = 19,
        AppleTV = 20,
        ReactNative = 21,
      }

      export enum FreeStatus {
        Normal = 0,
        WillExpire = 1,
        Expired = 2,
      }

      export enum OrgType {
        UNKNOWN_ORG = 0,
        COMPANY = 1,
        ORGANIZATION = 2,
        INDIVIDUAL = 3,
      }

      export enum AppForm {
        UNKNOWN_FORM = 0,
        APP = 1,
        SDK = 2,
        EXTENSION = 3,
      }

      export enum ProductExceedStatus {
        DEFAULT = 0,
        NORMAL = 1,
        HAS_ALREADY_EXCEED = 2,
        WILL_EXCEED = 3,
        WILL_EXPIRE = 4,
      }

      export enum OperationType {
        UNKNOWN_OPERATION = 0,
        RESUME = 1,
        STOP = 2,
      }

    }

  }

  export namespace eff_tool {
    export namespace common {
      export enum AppPlatform {
        UNKNOWN_PLATFORM = 0,
        ANDROID = 1,
        IOS = 2,
        WP7 = 3,
        MAC = 4,
        LINUX = 5,
        WP8 = 6,
        WINDOWS = 10,
        HARMONY = 11,
        WECHAT_MINI_PROGRAM = 12,
        QQ_MINI_PROGRAM = 13,
        HIPPY = 14,
        KUIKLY = 15,
        H5 = 16,
        VISION_OS = 17,
        MINI_PROGRAM = 18,
        ELECTRON = 19,
        APPLETV = 20,
        FLUTTER = 21,
      }

      export enum FeedbackType {
        IN_WRONG_ISSUE = 0,
        BELONG_TO_OTHER_ISSUE = 1,
        OTHER_FEEDBACK = 2,
      }

      export enum ClientType {
        OTHER_CLIENT = 0,
        WEB = 1,
        LANDUN_PLUGIN = 2,
        QCI = 3,
        SYMBOL_TOOL = 4,
        MIGRATE = 5,
        QQ_LANDUN = 6,
        QQ_SYMBOLTOOL = 7,
        BUGLY_CLOUD_TOOL = 8,
      }

      export enum SystemReservedFileType {
        UNKNOW = 0,
        STIF = 1,
        MAPPING = 2,
        SO = 3,
        DSYM = 4,
        WINDOWS_COMMON = 5,
        ZIP_STIF = 101,
        ZIP_MAPPING = 102,
        ZIP_SO = 103,
        ZIP_DSYM = 104,
        ZIP_WINDOWS = 105,
        ZIP_ZIP_MIX = 200,
        ZIP_ZIP_STIF = 201,
        ZIP_ZIP_MAPPING = 202,
        ZIP_ZIP_WINDOWS = 205,
      }

      export enum UploadFileType {
        UL_UNUSED = 0,
        UL_ZIP_ZIP_MIX = 200,
        UL_ZIP_ZIP_STIF = 201,
        UL_ZIP_ZIP_MAPPING = 202,
        UL_ZIP_ZIP_WINDOWS = 205,
      }

      export enum UploadSubFileType {
        SUB_UNUSED = 0,
        SUB_ZIP_STIF = 101,
        SUB_ZIP_MAPPING = 102,
        SUB_ZIP_WINDOWS = 105,
      }

      export enum StandardSymbolType {
        STD_UNUSED = 0,
        STD_STIF = 1,
        STD_MAPPING = 2,
        STD_WINDOWS = 5,
      }

      export enum BuildPlatform {
        OTHER_PLATFORM = 0,
        LANDUN = 1,
      }

      export enum BuildEnv {
        UNKNOWN_ENV = 0,
        DEVELOP = 1,
        TEST = 2,
        RELEASE = 3,
        MIGRATOR = 4,
      }

      export enum AppType {
        APP = 0,
        COMPONENT = 1,
      }

    }

  }

}
